import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { Trash2, Check, X, FileEdit } from "lucide-react";

const STATUS = {
  em_analise: { label:"Em análise", color:"var(--sun-700)", bg:"rgba(199,154,58,0.1)" },
  aprovada: { label:"Aprovada", color:"var(--success)", bg:"rgba(74,124,62,0.12)" },
  recusada: { label:"Recusada", color:"var(--danger)", bg:"rgba(179,58,58,0.08)" },
  correcoes: { label:"Correções solicitadas", color:"var(--sun-600)", bg:"rgba(233,204,133,0.15)" },
};

export default function PartnerApplicationsTab() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);

  const load = () => { api.get("/admin/partner-applications").then(r=>setItems(r.data)).catch(()=>{}); };
  useEffect(load, []);

  const update = async (aid, status) => {
    const notes = window.prompt(`Observações para o solicitante (opcional):`, "") || "";
    await api.patch(`/admin/partner-applications/${aid}`, { status, admin_notes: notes });
    toast.success("Status atualizado"); load();
  };
  const del = async (aid) => {
    if (!window.confirm("Excluir solicitação?")) return;
    await api.delete(`/admin/partner-applications/${aid}`); load();
  };

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-3">
        {items.map(a => {
          const st = STATUS[a.status] || STATUS.em_analise;
          return (
            <div key={a.application_id} className="card-arya p-5" data-testid={`app-${a.application_id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="tag-sun">{a.category}</span>
                    <span className="text-xs" style={{color:st.color, background:st.bg, padding:"2px 10px", borderRadius:999}}>{st.label}</span>
                  </div>
                  <p className="font-serif text-xl mt-2">{a.full_name}{a.company_name ? ` · ${a.company_name}` : ""}</p>
                  <p className="text-xs text-[color:var(--ink-500)]">{a.contact_email} · {a.contact_phone || "-"} · {a.region || "sem região"}</p>
                  <p className="text-sm text-[color:var(--ink-500)] mt-2"><b>Especialidades:</b> {a.specialties || "-"}</p>
                  <p className="text-sm text-[color:var(--ink-500)]"><b>Experiência:</b> {a.experience_years || "-"}</p>
                  <p className="text-sm text-[color:var(--ink-500)]"><b>Serviços:</b> {a.services || "-"}</p>
                  <p className="text-sm text-[color:var(--ink-500)]"><b>Preços:</b> {a.prices || "-"}</p>
                  {a.career_goals && <p className="text-sm text-[color:var(--ink-500)]"><b>Objetivos:</b> {a.career_goals}</p>}
                  {a.heard_about && <p className="text-xs text-[color:var(--ink-500)] mt-1 italic">Nos conheceu via: {a.heard_about}</p>}
                  {(a.photos?.length || a.videos?.length) ? (
                    <div className="mt-2 flex flex-wrap gap-2 text-xs">
                      {a.photos?.map((u,i)=><a key={"p"+i} href={u} target="_blank" rel="noreferrer" className="text-[color:var(--sun-700)] underline">📷 {i+1}</a>)}
                      {a.videos?.map((u,i)=><a key={"v"+i} href={u} target="_blank" rel="noreferrer" className="text-[color:var(--sun-700)] underline">🎬 {i+1}</a>)}
                    </div>
                  ) : null}
                  {a.admin_notes && <p className="text-xs mt-2 italic text-[color:var(--ink-500)]">Notas: {a.admin_notes}</p>}
                  <p className="text-[10px] text-[color:var(--ink-500)] mt-2">{new Date(a.created_at).toLocaleString("pt-BR")}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={()=>update(a.application_id, "aprovada")} className="btn-gold !py-1 !px-3 text-xs inline-flex items-center gap-1" data-testid={`approve-${a.application_id}`}><Check size={12}/> Aprovar</button>
                  <button onClick={()=>update(a.application_id, "correcoes")} className="btn-ghost !py-1 !px-3 text-xs inline-flex items-center gap-1"><FileEdit size={12}/> Correções</button>
                  <button onClick={()=>update(a.application_id, "recusada")} className="btn-ghost !py-1 !px-3 text-xs !text-[color:var(--danger)] !border-[color:var(--danger)]/40 inline-flex items-center gap-1"><X size={12}/> Recusar</button>
                  <button onClick={()=>del(a.application_id)} className="p-1 text-[color:var(--danger)]"><Trash2 size={14}/></button>
                </div>
              </div>
            </div>
          );
        })}
        {items.length===0 && <div className="card-arya p-10 text-center text-[color:var(--ink-500)]">Nenhuma solicitação recebida.</div>}
      </div>
      <div className="card-arya p-6 h-fit">
        <h3 className="font-serif text-lg mb-2">Como funciona</h3>
        <ul className="text-sm text-[color:var(--ink-500)] space-y-2 list-disc pl-5">
          <li>Candidaturas chegam pela página pública <b>/seja-parceiro</b></li>
          <li>Status inicial é <b>Em análise</b></li>
          <li>Aprovados ainda não aparecem como parceiros públicos automaticamente — crie manualmente em <b>Empresas</b> ou <b>Cupons</b></li>
          <li>Solicitante recebe status visual aqui; notificação por email requer habilitar Resend</li>
        </ul>
      </div>
    </div>
  );
}
